import { render, staticRenderFns } from "./MunicipalitiesSelectorItem.vue?vue&type=template&id=0ba30922&scoped=true&"
import script from "./MunicipalitiesSelectorItem.vue?vue&type=script&lang=js&"
export * from "./MunicipalitiesSelectorItem.vue?vue&type=script&lang=js&"
import style0 from "./MunicipalitiesSelectorItem.vue?vue&type=style&index=0&id=0ba30922&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba30922",
  null
  
)

export default component.exports